import { ICraJurisdiction } from 'src/types/ICra';
import lodash from 'lodash';
/**
 *
 * @param object IStringKeyValueObject  {
 *  key1: [{value1}, {value1}],
 *  key2: [{value1}, {value2}, {value3}]
 * }
 * @params uniqueField: string
 * @returns unique elements
 * {
 *   key1: [{value1}],
 *   key2: [{value1}, {value2}, {value3}]
 * }
 */
export const removeRepeatedElementsInNestedObjectArrays = (
  object: ICraJurisdiction,
  uniqueField: string,
) => {
  try {
    for (let [key, value] of Object.entries(object)) {
      //@ts-ignore filter unique elements for each key inside given object
      object[key] = [...new Map(value.map((item) => [item[uniqueField], item])).values()];
    }
    return object;
  } catch (error: any) {
    console.log(error && error.message);
  }
};

/**
 * @param object IStringKeyValueObject  {
 *  key1: [{value1}, {value2}],
 *  key2: [{value1}, {value2}, {value3}]
 * }
 * @params uniqueField: string
 * @returns unique elements
 * {
 *   key1: [{value2}, {value1}],
 *   key2: [{value3}, {value2}, {value1}]
 * }
 */
export const sortNestedFields = (object: ICraJurisdiction, sortingKey: string) => {
  for (let [key, value] of Object.entries(object)) {
    if (Array.isArray(value)) {
      //@ts-ignore filter unique elements for each key inside given object
      object[key] = value.sort(({ [sortingKey]: a }, { [sortingKey]: b }) => b - a);
    }
  }
  return object;
};

/**
 * This function will keep only the highest of the values inside the array of objects
 * e.g. 
 *   key1: [{value2}, {value1}],
 *   key2: [{value3}, {value2}, {value1}]
 will become
 *   key1: [{value2}],
 *   key2: [{value3}]

 * @param object IStringKeyValueObject
 * @param valueField the field to compare the highest value
 * @returns 
 */
export const keepHighestValueInNestedArrays = (object: ICraJurisdiction, valueField: string) => {
  for (let [key, value] of Object.entries(object)) {
    if (Array.isArray(value)) {
      // get the highest score
      const highestFieldValueItem = lodash.get(value[0], valueField);
      // @ts-ignore get only those fields in this nested field which have highest valuefield as above
      object[key] = value.filter((item: any) => item[valueField] === highestFieldValueItem);
    }
  }
  return object;
};

/**
 * converts [{}, {}] to
 * {
 *  key1: [{}],
 *  key2: [{}, {}]
 * }, given key exists in the array
 * @param array Array of values / objects
 * @param keyField the field to be used as pivot for converting to object map
 */
export const convertArraytoObjectValue = (array: any, keyField: string) => {
  const objectMap: any = {};
  for (let item of array) {
    const fieldValue = lodash.get(item, keyField);
    if (!objectMap[fieldValue]) {
      objectMap[fieldValue] = [];
    }
    objectMap[fieldValue].push(item);
  }
  return objectMap;
};
